/** Status Monitor telemetry streams. */
export const STATUS_MONITOR_HOST_WS_URL = 'wss://statusenrolment.modded.space/socket';
export const STATUS_MONITOR_MINECRAFT_WS_URL =
  'wss://statusenrolment.modded.space/minecraftsocket';

export const PUBLIC_STATUS_URL = 'https://status.modded.space';
